import { TestQueryModel } from '../../test-utils/types';

export const singleLineEmptyQuery: TestQueryModel = {
  query: '',
  tokens: [],
};
